<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>利润表（适用执行小企业会计准则的企业）</dt>

      <dd>
        <div>税款所属期间：{{ staticConfig.taxStartTime }} 至 {{ staticConfig.taxEndTime }}</div>
        <div>会小企02表 金额单位：元，至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" style="margin-bottom: 20px">
        <colgroup>
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="2" class="th-back">纳税人名称</td>
            <td colspan="2">
              <div id="nsrmc">{{ staticConfig.companyName }}</div>
            </td>
            <td colspan="2" class="th-back">纳税人识别号</td>
            <td colspan="2">
              <div id="nsrsbh">{{ staticConfig.creditCode }}</div>
            </td>
          </tr>
        </tbody>
      </table>

      <table border="1" cellspacing="0" cellpadding="4">
        <thead>
          <tr style="text-align: center">
            <th class="title01" width="34%">项&nbsp;&nbsp;&nbsp;&nbsp;目</th>
            <th class="title01" width="6%">行次</th>
            <th class="title01" width="30%">本年累计金额</th>
            <th class="title01" width="30%">本月(季)金额</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">一、营业收入</td>
            <td class="title01" style="text-align: center">1</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v1x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v1x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">减：营业成本</td>
            <td class="title01" style="text-align: center">2</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v2x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v2x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">税金及附加</td>
            <td class="title01" style="text-align: center">3</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v3x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v3x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">其中：消费税</td>
            <td class="title01" style="text-align: center">4</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v4x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v4x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">营业税</td>
            <td class="title01" style="text-align: center">5</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v5x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v5x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">城市维护建设税</td>
            <td class="title01" style="text-align: center">6</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v6x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v6x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">资源税</td>
            <td class="title01" style="text-align: center">7</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v7x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v7x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">土地增值税</td>
            <td class="title01" style="text-align: center">8</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v8x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v8x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">城镇土地使用税、房产税、车船税、印花税</td>
            <td class="title01" style="text-align: center">9</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v9x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v9x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v9x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v9x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">教育费附加、矿产资源补偿费、排污费</td>
            <td class="title01" style="text-align: center">10</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v10x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v10x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">销售费用</td>
            <td class="title01" style="text-align: center">11</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v11x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v11x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v11x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">其中：商品维修费</td>
            <td class="title01" style="text-align: center">12</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v12x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v12x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v12x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v12x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v12x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">广告费和业务宣传费</td>
            <td class="title01" style="text-align: center">13</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v13x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v13x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v13x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">管理费用</td>
            <td class="title01" style="text-align: center">14</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v14x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v14x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v14x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">其中：开办费</td>
            <td class="title01" style="text-align: center">15</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v15x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v15x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v15x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v15x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v15x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">业务招待费</td>
            <td class="title01" style="text-align: center">16</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v16x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v16x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v16x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v16x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v16x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v16x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">研究费用</td>
            <td class="title01" style="text-align: center">17</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v17x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v17x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v17x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v17x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v17x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">财务费用</td>
            <td class="title01" style="text-align: center">18</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v18x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v18x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">其中：利息费用（收入以“-”号填列）</td>
            <td class="title01" style="text-align: center">19</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v19x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v19x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v19x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v19x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v19x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v19x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">加：投资收益（损失以“-”号填列）</td>
            <td class="title01" style="text-align: center">20</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v20x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v20x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v20x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v20x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v20x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v20x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">二、营业利润（亏损以“-”号填列）</td>
            <td class="title01" style="text-align: center">21</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v21x1.value) }}</span>
                <!-- 初始数据 -->
                <!-- <el-input-number v-model.trim="data.v21x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
              </div>
            </td>
            <td class="d2">
              {{ parseFloatNum(data.v21x3.value) }}
              <!-- <el-input-number v-model.trim="data.v21x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">加：营业外收入</td>
            <td class="title01" style="text-align: center">22</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v22x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v22x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v22x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v22x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">其中：政府补助</td>
            <td class="title01" style="text-align: center">23</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v23x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v23x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v23x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v23x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v23x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">减：营业外支出</td>
            <td class="title01" style="text-align: center">24</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v24x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v24x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v24x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v24x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v24x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">其中：坏账损失</td>
            <td class="title01" style="text-align: center">25</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v25x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v25x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v25x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v25x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v25x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">无法收回的长期债券投资损失</td>
            <td class="title01" style="text-align: center">26</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v26x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v26x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v26x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v26x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v26x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">无法收回的长期股权投资损失</td>
            <td class="title01" style="text-align: center">27</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v27x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v27x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v27x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v27x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v27x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v27x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">自然灾害等不可抗力因素造成的损失</td>
            <td class="title01" style="text-align: center">28</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v28x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v28x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v28x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v28x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v28x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v28x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" style="text-indent: 2em">税收滞纳金</td>
            <td class="title01" style="text-align: center">29</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v29x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v29x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v29x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v29x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v29x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v29x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">三、利润总额（亏损总额以“-”号填列）</td>
            <td class="title01" style="text-align: center">30</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v30x1.value) }}</span>
                <!-- 初始数据 -->
                <!-- <el-input-number v-model.trim="data.v30x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
              </div>
            </td>
            <td class="d2">
              <span>{{ parseFloatNum(data.v30x3.value) }}</span>
              <!-- <el-input-number v-model.trim="data.v30x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">减：所得税费用</td>
            <td class="title01" style="text-align: center">31</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v31x1.value) }}</span>
                <!-- 初始数据 -->
                <el-input-number v-model.trim="data.v31x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
              </div>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v31x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v31x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v31x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v31x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr class="tr">
            <td class="title01">四、净利润（净亏损以“-”号填列）</td>
            <td class="title01" style="text-align: center">32</td>
            <td class="d1">
              <div class="td-s1">
                <!-- 做题数据 -->
                <span>{{ parseFloatNum(data.v32x1.value) }}</span>
                <!-- 初始数据 -->
                <!-- <el-input-number v-model.trim="data.v32x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
              </div>
            </td>
            <td class="d2">
              <span>{{ parseFloatNum(data.v32x3.value) }}</span>
              <!-- <el-input-number v-model.trim="data.v32x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};
function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 初始数据在第2列
        // 1-20行 1 = 2 + 3
        // 22-29行 1 = 2 + 3
        // 31行 1 = 2 + 3
        for (let row = 1; row <= 31; row++) {
          if ((row >= 1 && row <= 20) || (row >= 22 && row <= 29) || row == 31) {
            data.value[`v${row}x1`].value = new Big(data.value[`v${row}x2`].value).plus(data.value[`v${row}x3`].value).round(2).toNumber();
          }
        }

        for (let column = 1; column <= 3; column++) {
          // 初始数据在第2列 不参与列计算
          if (column != 2) {
            // 21 = 1-2-3-11-14-18+20
            data.value[`v21x${column}`].value = new Big(data.value[`v1x${column}`].value)
              .minus(data.value[`v2x${column}`].value)
              .minus(data.value[`v3x${column}`].value)
              .minus(data.value[`v11x${column}`].value)
              .minus(data.value[`v14x${column}`].value)
              .minus(data.value[`v18x${column}`].value)
              .plus(data.value[`v20x${column}`].value)
              .round(2)
              .toNumber();

            // 30 = 21+22-24
            data.value[`v30x${column}`].value = new Big(data.value[`v21x${column}`].value).plus(data.value[`v22x${column}`].value).minus(data.value[`v24x${column}`].value).round(2).toNumber();
            // 32 = 30-31
            data.value[`v32x${column}`].value = new Big(data.value[`v30x${column}`].value).minus(data.value[`v31x${column}`].value).round(2).toNumber();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;

  .td-s1 {
    display: flex;

    > span,
    > div {
      flex: 1;
    }

    > div {
      display: none;
    }
  }
}
</style>
<style lang="scss">
// 只有录入初始数据展示初始数据输入框并隐藏做题数据
// 其他模式隐藏初始数据输入框 展示做题数据
.question-mode-5 {
  .td-s1 {
    > span {
      display: none;
    }

    > div {
      display: flex !important;
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4">
  <thead>
      <tr style="text-align:center;">
          <th class="title01" width="34%">项&nbsp;&nbsp;&nbsp;&nbsp;目</th>
          <th class="title01" width="6%">行次</th>
          <th class="title01" width="30%">本年累计金额</th>
          <th class="title01" width="30%">本月(季)金额</th>
      </tr>
  </thead>
  <tbody>
      <tr class="tr">
          <td class="title01">一、营业收入</td>
          <td class="title01" style="text-align:center;">1</td>
          <td class="d1">
              <input type="text" class="input2 k1 i1" value="0" daan="67079.20">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i1" value="0" daan="67079.20">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">减：营业成本</td>
          <td class="title01" style="text-align:center;">2</td>
          <td class="d1">
              <input type="text" class="input2 k1 i2" value="0" daan="35500.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i2" value="0" daan="35500.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">税金及附加</td>
          <td class="title01" style="text-align:center;">3</td>
          <td class="d1">
              <input type="text" class="input2 k1 i3" value="0" daan="66.41">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i3" value="0" daan="66.41">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">其中：消费税</td>
          <td class="title01" style="text-align:center;">4</td>
          <td class="d1">
              <input type="text" class="input2 k1 i4" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i4" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">营业税</td>
          <td class="title01" style="text-align:center;">5</td>
          <td class="d1">
              <input type="text" class="input2 k1 i5" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i5" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">城市维护建设税</td>
          <td class="title01" style="text-align:center;">6</td>
          <td class="d1">
              <input type="text" class="input2 k1 i6" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i6" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">资源税</td>
          <td class="title01" style="text-align:center;">7</td>
          <td class="d1">
              <input type="text" class="input2 k1 i7" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i7" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">土地增值税</td>
          <td class="title01" style="text-align:center;">8</td>
          <td class="d1">
              <input type="text" class="input2 k1 i8" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i8" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">城镇土地使用税、房产税、车船税、印花税</td>
          <td class="title01" style="text-align:center;">9</td>
          <td class="d1">
              <input type="text" class="input2 k1 i9" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i9" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">教育费附加、矿产资源补偿费、排污费</td>
          <td class="title01" style="text-align:center;">10</td>
          <td class="d1">
              <input type="text" class="input2 k1 i10" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i10" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">销售费用</td>
          <td class="title01" style="text-align:center;">11</td>
          <td class="d1">
              <input type="text" class="input2 k1 i11" value="0" daan="9633.25">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i11" value="0" daan="9633.25">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">其中：商品维修费</td>
          <td class="title01" style="text-align:center;">12</td>
          <td class="d1">
              <input type="text" class="input2 k1 i12" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i12" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">广告费和业务宣传费</td>
          <td class="title01" style="text-align:center;">13</td>
          <td class="d1">
              <input type="text" class="input2 k1 i13" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i13" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">管理费用</td>
          <td class="title01" style="text-align:center;">14</td>
          <td class="d1">
              <input type="text" class="input2 k1 i14" value="0" daan="31990.20">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i14" value="0" daan="31990.20">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">其中：开办费</td>
          <td class="title01" style="text-align:center;">15</td>
          <td class="d1">
              <input type="text" class="input2 k1 i15" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i15" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">业务招待费</td>
          <td class="title01" style="text-align:center;">16</td>
          <td class="d1">
              <input type="text" class="input2 k1 i16" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i16   " value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">研究费用</td>
          <td class="title01" style="text-align:center;">17</td>
          <td class="d1">
              <input type="text" class="input2 k1 i17" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i17" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">财务费用</td>
          <td class="title01" style="text-align:center;">18</td>
          <td class="d1">
              <input type="text" class="input2 k1 i18" value="0" daan="-64.36">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i18" value="0" daan="-64.36">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">其中：利息费用（收入以“-”号填列）</td>
          <td class="title01" style="text-align:center;">19</td>
          <td class="d1">
              <input type="text" class="input2 k1 i19" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i19" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">加：投资收益（损失以“-”号填列）</td>
          <td class="title01" style="text-align:center;">20</td>
          <td class="d1">
              <input type="text" class="input2 k1 i20" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i20" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">二、营业利润（亏损以“-”号填列）</td>
          <td class="title01" style="text-align:center;">21</td>
          <td class="d1">
              <input type="text" class="input2 k1 i21" value="0" daan="-10046.30">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i21" value="0" daan="-10046.30">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">加：营业外收入</td>
          <td class="title01" style="text-align:center;">22</td>
          <td class="d1">
              <input type="text" class="input2 k1 i22" value="0" daan="164.37">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i22" value="0" daan="164.37">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">其中：政府补助</td>
          <td class="title01" style="text-align:center;">23</td>
          <td class="d1">
              <input type="text" class="input2 k1 i23" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i23" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">减：营业外支出</td>
          <td class="title01" style="text-align:center;">24</td>
          <td class="d1">
              <input type="text" class="input2 k1 i24" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i24" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">其中：坏账损失</td>
          <td class="title01" style="text-align:center;">25</td>
          <td class="d1">
              <input type="text" class="input2 k1 i25" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i25" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">无法收回的长期债券投资损失</td>
          <td class="title01" style="text-align:center;">26</td>
          <td class="d1">
              <input type="text" class="input2 k1 i26" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i26" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">无法收回的长期股权投资损失</td>
          <td class="title01" style="text-align:center;">27</td>
          <td class="d1">
              <input type="text" class="input2 k1 i27" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i27" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">自然灾害等不可抗力因素造成的损失</td>
          <td class="title01" style="text-align:center;">28</td>
          <td class="d1">
              <input type="text" class="input2 k1 i28" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i28" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01" style="text-indent: 2em;">税收滞纳金</td>
          <td class="title01" style="text-align:center;">29</td>
          <td class="d1">
              <input type="text" class="input2 k1 i29" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i29" value="0" daan="0.00">
          </td>
      </tr>

      <tr class="tr">
          <td class="title01">三、利润总额（亏损总额以“-”号填列）</td>
          <td class="title01" style="text-align:center;">30</td>
          <td class="d1">
              <input type="text" class="input1 k1 i30" value="0" daan="-9881.93">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input1 k2 i30" value="0" daan="-9881.93">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">减：所得税费用</td>
          <td class="title01" style="text-align:center;">31</td>
          <td class="d1">
              <input type="text" class="input2 k1 i31" value="0" daan="0.00">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input2 k2 i31" value="0" daan="0.00">
          </td>
      </tr>
      <tr class="tr">
          <td class="title01">四、净利润（净亏损以“-”号填列）</td>
          <td class="title01" style="text-align:center;">32</td>
          <td class="d1">
              <input type="text" class="input1 k1 i32" value="0" daan="-9881.93">
              <input type="hidden" value="NaN" class="nian" readonly="readonly" style="background: rgb(235, 235, 235);">
          </td>
          <td class="d2">
              <input type="text" class="input1 k2 i32" value="0" daan="-9881.93">
          </td>
      </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
